interface Props {
  color?: string
  className?: string
}

export default function TicketIcon({ color = '#000000', className }: Props) {
  return (
    <svg className={className} viewBox="0 0 1152 1024" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M128 128C57.4 128 0 185.4 0 256v128c0 17.6 14.8 31.4 31.4 37.2C69 434.2 96 470 96 512s-27 77.8-64.6 90.8C14.8 608.6 0 622.4 0 640v128c0 70.6 57.4 128 128 128h896c70.6 0 128-57.4 128-128v-128c0-17.6-14.8-31.4-31.4-37.2C1083 589.8 1056 554 1056 512s27-77.8 64.6-90.8c16.6-5.8 31.4-19.6 31.4-37.2v-128c0-70.6-57.4-128-128-128H128z m128 224v320c0 17.6 14.4 32 32 32h576c17.6 0 32-14.4 32-32V352c0-17.6-14.4-32-32-32H288c-17.6 0-32 14.4-32 32z m-64-32c0-35.4 28.6-64 64-64h640c35.4 0 64 28.6 64 64v384c0 35.4-28.6 64-64 64H256c-35.4 0-64-28.6-64-64V320z"
        fill={color}
      />
    </svg>
  )
}
